export default "__VITE_ASSET__ByJsxNno__"